module.exports = function(app) {
    app.directive('vitalsSmartshopper', function() {
        return {
            restrict: 'A',
            scope: {
                vitalsCoremetrics : '@'
            },
            template: require('directives/vitalsSmartshopper.html'),
            controller: ['$scope', 'services', 'session', 'modal', 'coremetrics', function ($scope, services, session, modal, coremetrics) {

                var vitalsSmartshopper = require('modals/vitalsSmartshopperModal.js');

                $scope.openVitalsSSOModal = function(){

                    coremetrics.elementTag('VITALS SMARTSHOPPER', $scope.vitalsCoremetrics);
                    coremetrics.pageviewTag($scope.vitalsCoremetrics+':VITALS SMARTSHOPPER MODAL', $scope.vitalsCoremetrics);

                    modal.open({
                       template: require('modals/vitalsSmartshopperModal.html'),
                       controller: vitalsSmartshopper,
                       scope: $scope
                    });
                };
            }]
        };
    });
};
